export enum CompetitionCoverSize {
    default = 1,
    square = 1.48,
    wide = 1.9
}

export enum CompetitionCoverOrientation {
    row = 'row',
    column = 'column'
}export enum CompetitionCoverSize {
    default = 1,
    square = 1.48,
    wide = 1.9
}

export enum CompetitionCoverOrientation {
    row = 'row',
    column = 'column'
}